// extracted by mini-css-extract-plugin
module.exports = {"footerColor":"footer-module--footerColor--FhleV","footerStyle":"footer-module--footerStyle--2MUab","logo":"footer-module--logo--3_naa"};